<span
  class="control"
  [attr.data-icon-position]="icon() ? iconPosition() : undefined"
>
  @if (label()) {
    <span class="control__label">{{ label() }}</span>
  }

  <span class="control__input">
    @if (icon()) {
      <i class="control__input_icon icon" [class]="icon()"></i>
    }

    <button
      #controlButton
      type="button"
      class="control__input_button"
      [ngClass]="{ hidden: !buttonLabel() }"
      [disabled]="isDisabled() || buttonLoading() || buttonDisabled()"
      (click)="onButtonClick($event)"
    >
      {{ buttonLabel() }}

      @if (buttonLoading()) {
        <app-loader class="control__input_button_loader" />
      }
    </button>

    @let buttonWidth = buttonLabel() ? controlButton.clientWidth + 16 : null;
    <input
      class="control__input_controller"
      [ngClass]="{ outline: outline(), 'has-password-toggle': type() === 'password' }"
      [style.padding-right.px]="buttonWidth"
      [type]="inputType"
      [value]="value()"
      [attr.name]="name()"
      [placeholder]="placeholder()"
      [attr.autocomplete]="autocomplete()"
      [disabled]="isDisabled()"
      [attr.data-style]="style()"
      [attr.data-size]="size()"
      [mask]="mask() || ''"
      [showMaskTyped]="showMaskTyped()"
      [hiddenInput]="hiddenInput()"
      (input)="onValueChange($event)"
      (blur)="onTouched()"
      (keydown.enter)="onEnterKey($event)"
    />

    @if (type() === 'password') {
      <i
        class="control__input_icon control__input_icon--eye"
        [class]="showPassword() ? 'icon-eye' : 'icon-eye-slash'"
        (click)="togglePasswordVisibility()"
      ></i>
    }
  </span>
</span>
